<div *ngIf="loading"
     class="absolute top-0 bottom-0 left-0 right-0 z-50 flex items-center justify-center bg-white/80">
  <div class="w-[60px] h-[60px] -mt-[30px]">
    <ion-spinner name="circular" class="text-primary"></ion-spinner>
  </div>
</div>
